import { render, staticRenderFns } from "./listHavoblog.vue?vue&type=template&id=1dd87611&"
import script from "./listHavoblog.vue?vue&type=script&lang=js&"
export * from "./listHavoblog.vue?vue&type=script&lang=js&"
import style0 from "./listHavoblog.vue?vue&type=style&index=0&id=1dd87611&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports